import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\DossierNumbering\UpdateDossierNumberingController::__invoke
* @see app/Http/Controllers/DossierNumbering/UpdateDossierNumberingController.php
* @route '/api/dossier-numbering/{dossier_numbering}'
*/
const UpdateDossierNumberingController = (args: { dossier_numbering: string | number | { id: string | number } } | [dossier_numbering: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierNumberingController.url(args, options),
    method: 'put',
})

UpdateDossierNumberingController.definition = {
    methods: ["put"],
    url: '/api/dossier-numbering/{dossier_numbering}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\DossierNumbering\UpdateDossierNumberingController::__invoke
* @see app/Http/Controllers/DossierNumbering/UpdateDossierNumberingController.php
* @route '/api/dossier-numbering/{dossier_numbering}'
*/
UpdateDossierNumberingController.url = (args: { dossier_numbering: string | number | { id: string | number } } | [dossier_numbering: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier_numbering: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier_numbering: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier_numbering: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier_numbering: typeof args.dossier_numbering === 'object'
        ? args.dossier_numbering.id
        : args.dossier_numbering,
    }

    return UpdateDossierNumberingController.definition.url
            .replace('{dossier_numbering}', parsedArgs.dossier_numbering.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\DossierNumbering\UpdateDossierNumberingController::__invoke
* @see app/Http/Controllers/DossierNumbering/UpdateDossierNumberingController.php
* @route '/api/dossier-numbering/{dossier_numbering}'
*/
UpdateDossierNumberingController.put = (args: { dossier_numbering: string | number | { id: string | number } } | [dossier_numbering: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierNumberingController.url(args, options),
    method: 'put',
})

export default UpdateDossierNumberingController